<template>
  <div class="tinkerToolbar">
      <a href="#" title="Run Code (Ctrl+R)">
        <img v-if="autoEvaluate" class="icon" src="./../../assets/icons/autorun.png">
        <img v-else @click.prevent="runCode" class="icon" src="./../../assets/icons/run.png">
      </a>
      <a v-if="mode === 'cli'" href="#" class="flex items-center justify-center text-gray-200 block text-sm icon font-mono" @click.prevent="setMode('http')" title="HTTP Mode" >
        HTTP
      </a>
      <a v-if="mode === 'http'" href="#" class="flex items-center justify-center text-gray-200 block text-sm icon font-mono" @click.prevent="setMode('cli')" title="CLI Mode" >
        CLI
      </a>
      <a href="#" @click.prevent="openWorkingDirectory" title="Set working directory"><img class="icon" src="./../../assets/icons/folder.png"></a>
      <a href="#" @click.prevent="connectSSH" title="Connect SSH" >
        <img class="icon" src="./../../assets/icons/connect.png">
      </a>
      <a href="#" @click.prevent="openDocumentation" title="Documentation" >
        <img class="icon" src="./../../assets/icons/laravel.png">
      </a>
      <div style="flex-grow: 1">&nbsp;</div>
      <a href="#" title="Preferences" @click.prevent="showSettings"><img class="last icon" src="./../../assets/icons/settings.png"></a>
  </div>
</template>

<script>
import Swal from 'sweetalert2';

export default {
  data() {
    return {
    };
  },

  computed: {
    autoEvaluate() {
      return this.$store.state.Code.autoEvaluate;
    },
    mode() {
      return this.$store.state.Code.mode;
    },
  },

  methods: {
    openDocumentation() {
      this.$store.dispatch("showDocumentation", true);
    },
    openWorkingDirectory() {
      Swal.fire({
        imageUrl: 'https://tinkerwell.app/images/icon.png',
        imageWidth: 150,
        imageHeight: 150,
        title: 'Open a local project',
        html: '<p class="pb-2 font-bold">This feature is available in the Tinkerwell app only.</p><p>With Tinkerwell, you can access your database via Eloquent models (<a class="border-b border-dashed border-black" href="https://tinkerwell.app/tutorials/1-tinker-with-your-database" target="_blank">read more</a>), follow model relationships or just tinker around.</p>',
        confirmButtonText: 'Get Tinkerwell app',
        showCloseButton: true,
        showCancelButton: true,
        cancelButtonText: 'Cancel',
      }).then((result) => {
        if (result.value) {
          window.open('https://tinkerwell.app/?ref=playground', '_blank');
        }
      });
    },
    connectSSH() {
      Swal.fire({
        imageUrl: 'https://tinkerwell.app/images/icon.png',
        imageWidth: 150,
        imageHeight: 150,
        title: 'Connect to remote projects via SSH',
        html: '<p class="pb-2 font-bold">This feature is available in the Tinkerwell app only.</p><p>Tinkerwell connects to your remote Laravel applications via SSH and gives you a secure and convenient access to them.</p>',
        confirmButtonText: 'Get Tinkerwell app',
        showCloseButton: true,
        showCancelButton: true,
        cancelButtonText: 'Cancel',
      }).then((result) => {
        if (result.value) {
          window.open('https://tinkerwell.app/?ref=playground', '_blank');
        }
      });
    },
    runCode() {
      this.$root.$emit('php.run.tinkerwell');
    },
    setMode(mode) {
      this.$store.dispatch('setPreference', {
        key: 'mode',
        value: mode
      })
    },
    showSettings() {
      this.$parent.showSettings = true;
    },
  },
};
</script>

<style>
.tinkerToolbar {
  text-align: center;
  background: #31323c;
  background-color: #31323c;
  display: flex;
  flex-direction: column;
  width: 50px;
  height: 100%;
  border-right: 1px solid black;
}
.icon {
  cursor: pointer;
  width: 25px;
  height: 25px;
  margin: 8px 12px;
}
.icon.last {
  align-self: flex-end;
}
</style>
